/**
 * The Timer workspace's frame (manager redesign, 2026-10-09): one header over Gjennomgang
 * (/timeliste) and Registreringer (/arbeidstid), so the two pages read as one place. «Last ned»
 * holds the files each page writes from what it has loaded; the Personalliste and the §10-7 print
 * moved to Rapporter (#173, owner 2026-10-19: Rapporter holds what leaves the app).
 */
import { useCan } from '@/auth/caps';
import { T } from '@/i18n';
import { Menu } from '@/ui';
import { Icon } from '@/ui/icons';
import { PageHead, Tabs } from '@/ui/page';
import { useNavigate } from 'react-router-dom';
import { worktimeViews } from '../lonn/Head';
import './timer.css';

export interface ReportItem {
  key: string;
  label: string;
  onSelect: () => void;
  disabled?: boolean;
}

export function TimerHead({
  tab,
  count,
  reports = [],
  onAdd,
}: {
  tab: 'gjennomgang' | 'registreringer';
  /** finished shifts that need a person, for the Gjennomgang tab's badge */
  count?: number | null;
  /** the files this page can write now */
  reports?: ReportItem[];
  /** the manual registration; shown only with timeliste.rette */
  onAdd?: () => void;
}) {
  const can = useCan();
  const go = useNavigate();
  // without Rapporter (pay.view) the Personalliste and the §10-7 print stay reachable here
  const items = can('timerloenn.se') ? reports : [...reports, ...worktimeViews(go)];
  return (
    <PageHead
      title={T('Kontroll')}
      sub={T('Kontroller arbeidstiden, og behold hele registreringen.')}
      actions={
        <>
          <Menu
            items={items}
            trigger={
              <button type="button" className="btn" data-testid="timer-reports">
                <Icon name="download" />
                {T('Last ned')}
              </button>
            }
          />
          {onAdd && can('timeliste.rette') && (
            <button type="button" className="btn pri" onClick={onAdd}>
              <Icon name="plus" />
              {T('Legg til registrering')}
            </button>
          )}
        </>
      }
    >
      <Tabs
        label={T('Kontroll')}
        value={tab}
        items={[
          {
            key: 'gjennomgang',
            label: T('Gjennomgang'),
            to: '/timeliste',
            count: count ?? null,
            ...(count ? { aria: `${T('Gjennomgang')}, ${count} ${T('trenger vurdering')}` } : {}),
          },
          { key: 'registreringer', label: T('Registreringer'), to: '/arbeidstid' },
        ]}
      />
    </PageHead>
  );
}
